import { IDropdownValue } from '@cian/components/lib/components/abstract_components/dropdown/dropdown';

import { CoworkingPriceTypeDropdownModel } from './CoworkingPriceTypeDropdownModel';

export class CoworkingPriceTypeDropdownCollectionModel {
  public readonly collection: Array<IDropdownValue>;

  public constructor(...collection: Array<CoworkingPriceTypeDropdownModel>) {
    this.collection = collection;
  }
}
